import type { FaireProductEntity } from "../../entity_types/product";

export const p_4snuqcrty5: FaireProductEntity = {
  token: "p_4snuqcrty5",
  type: "product",
  name: "Crystal Healing for Animals by Martin Scott",
  brandToken: "b_7a909d43",
  brandName: "Simon & Schuster",
  imageUrl:
    "https://cdn.faire.com/fastly/150b5c72aad4165f03c34750c5dfd11036da03d1a1b14e64e3c8031590ff347b.jpeg",
  galleryImageUrls: [],
  priceDollars: 10.36,
  description:
    "[Inner Traditions]\r\n\r\nDiscover how the healing power of crystals can be used to enhance the wellbeing and happiness of the animals in your care. \r\n\r\nCrystal healing is as effective and potent a healing art today as it was in the time of the ancient Egyptians. It is even more effective with animals than for humans, and any pet owner or animal caregiver can easily learn to master the basic techniques of choosing and cleansing crystals, dowsing and crystal massage, making crystal essences, and the use of crystal layouts in healing. Crystal Healing for Animals explains these methods in plain and simple language and will be useful for beginners and experienced crystal users alike. \r\n\r\nCrystal healing allows us to take an active role in the health of our animal companions, in the sure knowledge that we can do no wrong. Crystals have a healing energy that is powerful and profound, but is completely safe and gentle. \r\n\r\nTake a guided tour of thirty of the most commonly used and effective heali",
  tags: [],
  msrpDollars: 20.72,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:48:35.775Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
